import React from "react";
import type { ApolloClient } from "@apollo/client";
import { connect, type ConnectedProps } from "react-redux";
import { withApollo, type WithApolloClient } from "@apollo/client/react/hoc";

import SimpleModal from "components/SimpleModal";
import { createErrorSelector, createLoadingSelector } from "store/selectors";
import { disableCompany } from "actions/adminActions";
import { adminConstants } from "actions/types";
import { toast } from "react-toastify";
import { get } from "lodash";
import type { Company } from "types/models";
import type { RootState } from "types/state";

const isFetchingSelector = createLoadingSelector(
  adminConstants.DISABLE_COMPANY
);
const errorSelector = createErrorSelector(adminConstants.DISABLE_COMPANY);

const mapStateToProps = (state: RootState) => {
  return {
    isFetching: isFetchingSelector(state),
    error: errorSelector(state),
  };
};

const mapDispatchToProps = {
  disableCompany,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

interface OwnProps {
  onClose: (clickingOutsideModal?: boolean) => void;
  onSuccess: (currentState: string) => void;
  company: Company;
}

type Props = WithApolloClient<OwnProps & PropsFromRedux>;

class DisableCompanyModal extends React.PureComponent<Props> {
  _disableCompany = () => {
    void this.props
      .disableCompany(
        this.props.client as ApolloClient<object>,
        this.props.company.id
      )
      .then((result) => {
        if (result.success) {
          this.props.onSuccess(get(result, "data.state", "") as string);
          toast.success("Successfully disabled company.");
        }
      });
  };

  render() {
    return (
      <SimpleModal
        show={true}
        onClose={this.props.onClose}
        onSubmit={this._disableCompany}
        title="Disable Company"
        buttonText="Disable"
        closeButtonText="Cancel"
        isXhrRequest={true}
        error={this.props.error}
        isFetching={this.props.isFetching}
      >
        <p>
          {"Are you sure you want to disable "}
          <b>{this.props.company.name}</b>
          {
            "? Admins and agents will lose access, and groups, bank accounts, and employee links will be removed. The company can be re-enabled later, but removed data is not restored."
          }
        </p>
      </SimpleModal>
    );
  }
}

export default connector(withApollo<Props>(DisableCompanyModal));
